import { render } from "./stats.vue?vue&type=template&id=b97d04d8&ts=true"
import script from "./stats.vue?vue&type=script&lang=ts"
export * from "./stats.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__